import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\VS Code\\enqdigital.com.br\\hbuilds\\last-source\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
